<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img class="user-avatar" :src="avatar">
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
        <el-dropdown-item divided>
          <span @click="dialogFormVisible = true" style="display:block;">修改密码</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <div>
      <el-dialog title="修改密码" width="500px" :visible.sync="dialogFormVisible">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px">
          <el-form-item label="旧密码" prop="oldPassword">
            <el-input type="password" v-model="ruleForm.oldPassword" auto-complete="off" class="password-input"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="password">
            <el-input type="password" v-model="ruleForm.password" auto-complete="off" class="password-input"></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="checkPassword">
            <el-input type="password" v-model="ruleForm.checkPassword" auto-complete="off" class="password-input"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm()" v-bind:disabled="isDisabled">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import store from '@/store';
import { editPassword } from '@/api/login';

export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '' || !value) {
        this.isDisabled = false;
        callback(new Error('请输入旧密码'));
      } else {
        if (this.ruleForm.oldPassword !== '') {
          callback();
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '' || !value) {
        this.isDisabled = false;
        callback(new Error('请输入新密码'));
      } else {
        callback();
      }
    };
    var validatePass3 = (rule, value, callback) => {
      if (value === '' || !value) {
        this.isDisabled = false;
        callback(new Error('请再次输入新密码'));
      } else if (value !== this.ruleForm.password) {
        this.isDisabled = false;
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      dialogFormVisible: false,
      isDisabled: false,
      count: 5,
      form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        },
        ruleForm: {
          oldPassword: '',
          password: '',
          checkPassword: ''
        },
        rules: {
          oldPassword: [
            { validator: validatePass, trigger: 'blur' }
          ],
          password: [
            { validator: validatePass2, trigger: 'blur' }
          ],
          checkPassword: [
            { validator: validatePass3, trigger: 'blur' }
          ]
        },
        formLabelWidth: '120px'
    }
  },
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    async submitForm(){
        try {
          this.isDisabled = true;
          const result = await editPassword(this.ruleForm);
          if(result.data){

            this.timer = setInterval(() => {
              if (--this.count <= 0) {
                clearInterval(this.timer);
                this.timer = null;
                //退出登录，自动跳转到登录页面
                store.dispatch('FedLogOut').then(() => {
                  location.reload()// 为了重新实例化vue-router对象 避免bug
                })
              }
            }, 1000)
            this.$alert('修改成功, 即将跳转登录页面', '密码修改成功', {
              confirmButtonText: '确定',
              callback: action => {
                clearInterval(this.timer);
                this.timer = null;
                store.dispatch('FedLogOut').then(() => {
                  location.reload()// 为了重新实例化vue-router对象 避免bug
                })
              }
            });
          } else{
            this.isDisabled = false;
            this.$message({message: '修改密码失败, 请稍后再试!',type: 'error'});
          }
        } catch(e){
          this.isDisabled = false;
          console.log('异常')
          throw e;
        }
      }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
  .password-input {
    width: 280px;
    right: 90px;
    left: 0px;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue